import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import { Fade, Overline } from "@/components/Reveal";
import { api } from "@/lib/api";

const InsightDetail = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/insights/${slug}`)
      .then((res) => setArticle(res.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-32" data-testid="insight-not-found">
        <p className="font-serif text-3xl text-ink">This article could not be found.</p>
        <Link to="/insights" className="mt-6 inline-block text-sm uppercase tracking-[0.18em] font-semibold text-burgundy link-underline">
          Back to Insights
        </Link>
      </div>
    );
  }

  if (!article) {
    return <div className="max-w-7xl mx-auto px-6 lg:px-10 py-32" data-testid="insight-loading" />;
  }

  return (
    <>
      <SEO title={`${article.title} | Mosaicon Strategies Insights`} description={article.excerpt || article.title} />
      <article className="max-w-3xl mx-auto px-6 py-20 md:py-28" data-testid="insight-article">
        <Fade>
          <Link
            to="/insights"
            data-testid="insight-back-link"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-ink/50 hover:text-burgundy transition-colors duration-300"
          >
            <ArrowLeft className="h-4 w-4" /> Insights
          </Link>
        </Fade>
        <Fade delay={0.1}>
          <Overline className="mt-10">{article.category}</Overline>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight text-ink leading-tight" data-testid="insight-title">
            {article.title}
          </h1>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-ink/40">
            {new Date(article.created_at).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })}
          </p>
        </Fade>
        <Fade delay={0.2} className="mt-12 space-y-6" data-testid="insight-body">
          {article.body.split(/\n{2,}/).map((para, i) => (
            <p key={i} className="text-base md:text-lg leading-relaxed text-ink/75">
              {para}
            </p>
          ))}
        </Fade>
      </article>
    </>
  );
};

export default InsightDetail;
